<template>
  <div class="relative block flex-shrink-0" :class="{ 'opacity-75': disabled }">
    <div class="relative" :class="disabled ? 'cursor-not-allowed' : ''">
      <div
        :class="[
          focus ? 'border-light-purple' : 'border-grey-200',
          disabled ? 'pointer-events-none bg-grey-100' : 'bg-pure-white'
        ]"
        class="relative w-full flex items-center gap-2 border rounded cursor-pointer h-10 pl-4 pr-8"
        @click.prevent="focus = true"
      >
        <BlIcon
          :data-id="id"
          :icon="'arrow-up'"
          color="slate-6"
          class="w-4 h-4 transition-all duration-300"
          :style="{ rotate: value.secondary === 'asc' ? '0deg' : '180deg' }"
          :title="value.secondary === 'asc' ? 'Ascending' : 'Descending'"
        />
        <BlTextBody2
          v-if="getLabelPrimary(value)"
          :text="getLabelPrimary(value)"
          class="text-slate-1000 truncate"
        />
        <BlIcon
          :data-id="id"
          :icon="'chevron-down'"
          class="absolute w-4 h-4 transition-all duration-300 right-3"
          :class="[disabled ? 'pointer-events-none cursor-not-allowed' : '']"
          :style="{ rotate: focus ? '180deg' : '' }"
        />
      </div>
      <div
        :data-id="id"
        v-if="!disabled && focus"
        class="absolute mt-2 max-h-64 min-w-104 w-full flex flex-col gap-2 flex-shrink-0 z-50 p-2 bg-pure-white rounded border border-grey-200 shadow-md"
        :class="{ 'right-0': dropDirection === 'left' }"
      >
        <div
          :data-id="id"
          class="px-4 py-2 flex items-center justify-between border-b border-slate-400"
        >
          <BlTextSubtitle2 :data-id="id" text="Sort by" />
          <div :data-id="id" class="cursor-pointer" @click.prevent="onClearAll">
            <BlTextSubtitle2
              :data-id="id"
              class="text-light-purple hover:text-dark-purple-200"
              text="Clear all"
            />
          </div>
        </div>
        <div :data-id="id" class="grid grid-cols-2 items-center gap-2">
          <BlSelectBox
            :dataId="id"
            v-model="primaryInput"
            :options="options.primary"
            @change="primaryInput = $event"
          />
          <BlSelectBox
            :dataId="id"
            v-model="secondaryInput"
            :options="options.secondary"
            @change="secondaryInput = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlSelectBox from "./BlSelectBox.vue";
import BlTextBody2 from "./BlTextBody2.vue";
import BlTextBody3 from "./BlTextBody3.vue";
import BlTextSubtitle2 from "./BlTextSubtitle2.vue";

export default {
  components: {
    BlIcon,
    BlTextBody3,
    BlTextBody2,
    BlTextSubtitle2,
    BlSelectBox
  },
  name: "BlSort",
  props: {
    disabled: { type: Boolean },
    value: { type: Object, default: () => ({ primary: "", secondary: "" }) },
    options: { type: Object, default: () => ({ primary: [], secondary: [] }) }, // { value, label }[]
    defaultValue: {
      type: Object,
      default: () => ({ primary: "", secondary: "" })
    }, // use for `Clear all`
    dropDirection: { type: String, default: "right " }
    // @change(value)
  },
  data() {
    return {
      primaryInput: "",
      secondaryInput: "",
      focus: false,
      query: ""
    };
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-sort-${combination}`;
    }
  },
  watch: {
    focus(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      } else {
        this.onChange({
          primary: this.primaryInput,
          secondary: this.secondaryInput
        });
      }
    },
    value(val) {
      this.generateValue(val);
    }
  },
  mounted() {
    this.generateValue(this.value);
  },
  methods: {
    generateValue(val) {
      this.primaryInput = val.primary;
      this.secondaryInput = val.secondary;
    },
    getLabelPrimary(val) {
      const found = this.options.primary.find(i => i.value === val.primary);
      return found ? found.label : "";
    },
    onClearAll() {
      this.primaryInput = this.defaultValue.primary;
      this.secondaryInput = this.defaultValue.secondary;
    },
    onChange(val) {
      this.$emit("change", val);
    },
    closeHandler(e) {
      let close = true;
      if (e.target && e.target.dataset && e.target.dataset.id) {
        const id = e.target.dataset.id || "";
        if (id === this.id) close = false;
        if (id.includes(this.id)) close = false;
      }
      if (close) {
        window.removeEventListener("click", this.closeHandler);
        this.focus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BlSort.vue